<template>
  <div class='tl-tab'>
    <slot>

    </slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.tl-tab{
  display: none;
}
</style>
